<svg width="20" height="18" fill="none" version="1.1" viewBox="0 0 20 18" xmlns="http://www.w3.org/2000/svg">
 <path d="M15.751 0H18.818L12.118 7.625L20 18H13.828L8.995 11.707L3.464 18H0.394L7.561 9.845L0 0H6.328L10.698 5.752L15.751 0ZM14.675 16.172H16.375L5.404 1.732H3.58L14.675 16.172Z" fill="#7A7882"/>
</svg>
